import React, { useEffect, useState, useMemo } from 'react'
import Select from "react-select"
import label from '../../../../../../../../assets/i18n/en.json'
import moment from 'moment'
// Common service
import UserService from '../../../../../../../services/api/user.service'
import ModalBox from '../../../../../../templates/components/ModalBox'
import UserEdit from '../user-edit/UserEdit'
import MessageSetting from '../../../../../../../common/constants/message-setting.constant'
import ResetPasswordService from '../../../../../../../services/api/reset-password.service'
import toast from 'react-hot-toast'
import Table2 from '../../../../../../templates/components/Table2'
import Utilities from '../../../../../../../services/commonservice/utilities'
import UserAdd from '../user-add/UserAdd'
import RoleService from '../../../../../../../services/api/role.service'

const UserSettingsTable = (props) => {
    // Temp var holders
    const hiddenColumns = ["mobile", "email", "doctorId", "createdOn", "name"]
    const [isLoader, setIsLoader] = useState(false)
    const [showAdd, setShowAdd] = useState(false)
    const [openModal, setOpenModal] = useState(false)
    const [statusModal, setStatusModal] = useState(false)
    const [resetModal, setResetModal] = useState(false)
    const [userStatus, setUserStatus] = useState('')
    const [userList, setUserList] = useState(props.list)
    const [id, setId] = useState('')
    const [providerId, setProviderId] = useState('')
    const [usersType, setUserType] = useState()
    // const [isAdmin, setIsAdmin] = useState(true)
    const [roles, setRoles] = useState()
    const [selectedUser, setSelectedUser] = useState()

    const desktopHiddenColumns = useMemo(() => {
        if (props.isEmbedded) {
            return (
                ['mobile', 'email', 'createdOn']
            )
        }
        else {
            return false
        }
    },[props.isEmbedded])

    const getRoles = () => {
        let reqObj = {}
        if (props.practiceId) {
            reqObj.practiceId = props.practiceId
        }
        RoleService.find(reqObj)
            .then(res => {
                if (res?.data?.data) {
                    console.log(res)
                    setRoles(res.data.data)
                }
            })
    }

    useEffect(() => {
        if (props.userTypes) {
            setRoles(props.userTypes)
        }
        else {
            getRoles()
        }
    }, [])
    const columns = [
        {
            id: "userName",
            Header: "Username",
            accessor: user => user.userName
        },
        {
            id: "name",
            Header: "Name",
            accessor: (practicePatient, i) => `${practicePatient.contact.name.firstName} ${practicePatient.contact.name.lastName}`
        },
        {
            id: "mobile",
            Header: "Phone",
            accessor: (practicePatient, i) => practicePatient.contact.mobile ? Utilities.toPhoneNumber(practicePatient.contact.mobile) : null
        },
        {
            id: "email",
            Header: "Email",
            accessor: (practicePatient) => practicePatient.contact.email
        },
        {
            id: "roleId",
            Header: "Role",
            accessor: (practicePatient) => roles && roles.find(obj => obj.id === practicePatient.roleId)?.roleName
        },
        {
            id: "createdOn",
            Header: "Created On",
            accessor: (practicePatient, i) => moment(practicePatient.createdOn).format("MM-DD-YYYY")
        },
        {
            id: "doctorId",
            Header: "Provider",
            accessor: (practicePatient, i) => practicePatient.doctorId ? 'Yes' : 'No'
        },
        {
            id: "status",
            Header: "Status",
            accessor: (practicePatient, i) => practicePatient.isActive ? <span className='btn btn-success text-white w-100'>Active</span> : <span className='btn btn-danger text-white w-100'>Inactive</span>
        },
        {
            id: "actionPracticePatient",
            Header: "Action",
            disableSortBy: true,
            textAlign: 'center',
            accessor: (user, i) => {
                return (
                    <div className='d-flex justify-content-center'>
                        <div className='btn-group'>
                            <button className="p-0 ps-1 btn btn-primary" title="Edit User" onClick={e => { e.preventDefault(); setSelectedUser(user); return setOpenModal(true) }}><i className="icon pencil" /></button>
                            <button className="p-0 ps-1 btn btn-primary" title={user.isActive ? 'Deactivate User' : 'Activate User'} onClick={e => { e.preventDefault(); setSelectedUser(user); return setStatusModal(true) }}>{user.isActive ? <i className="icon dont" /> : <i className="icon check" />}</button>
                            {user.isActive && <button className="p-0 ps-1 btn btn-primary" title="Reset Password" onClick={e => { e.preventDefault(); setSelectedUser(user); return setResetModal(true) }}><i className="icon lock" /></button>}
                        </div>
                    </div>
                )
            }
        }
    ]


    const resetHandler = () => {
        let reqObj = { 'isReset': true, 'userType': selectedUser.userType };
        if (props.practiceId) {
            reqObj.practiceId = props.practiceId
        }
        ResetPasswordService.resetPassword(reqObj, selectedUser.id, selectedUser.userType, false).then(
            toast.success(MessageSetting.LoginServiceuser.resetPassword),
            console.log('reset'),
            setResetModal(false)
        ).catch(err => console.log(err))
    }

    const statusHandler = () => {
        if (!selectedUser.isActive) {
            UserService.activateUser(selectedUser.id).then(response => {
                toast.success(MessageSetting.LoginServiceuser.activate)
                console.log('activate')
                setStatusModal(false)
                findUser()
            })
        } else {
            UserService.deactivateUser(selectedUser.id).then(response => {
                toast.success(MessageSetting.LoginServiceuser.deactivate)
                console.log('deactivate')
                setStatusModal(false)
                findUser()
            })
        }

    }


    const mapCountryName = (countryId) => {
        for (let i = 0; i < countryList.length; i++) {
            const element = countryList[i];
            if (countryList[i].countryId === countryId) {
                return countryList[i].name;
            }
        }
    }

    const getUserDetail = (user) => {
        console.log(user)
        // setVisible((prevState) => (!prevState))
        if (user.showDetails) {
            user.showDetails = !user.showDetails;
            return;
        }
        user.isLoader_UserDetails = true; // need to remove
        user.isLoader_UserOperation = true;
        let url = '';
        if (user.contact.url !== '' && user.contact.url !== null) {
            if (!/^http[s]?:\/\//.test(user.contact.url)) {
                url += 'http://';
            }
            url += user.contact.url;
        }
        user.contact.url = url;
        const addressObj = user.contact.address;
        let fullAddress = `${addressObj.addressLine1}${addressObj.addressLine2}${addressObj.city}${addressObj.state}${addressObj.country}${addressObj.postalCode}`;
        if (fullAddress !== '') {
            addressObj.country = (addressObj.country !== '' && addressObj.country != null) ? mapCountryName(addressObj.country) : '';
            fullAddress = '';
            fullAddress = (addressObj.addressLine1 !== '' && addressObj.addressLine1 != null) ? `${addressObj.addressLine1}, ` : '';
            fullAddress = (addressObj.addressLine2 !== '' && addressObj.addressLine2 != null) ? `${fullAddress}${addressObj.addressLine2}, ` : `${fullAddress}`;
            fullAddress = (addressObj.city !== '' && addressObj.city != null) ? `${fullAddress}${addressObj.city}, ` : `${fullAddress}`;
            fullAddress = (addressObj.state !== '' && addressObj.state != null) ? `${fullAddress}${addressObj.state}, ` : `${fullAddress}`;
            fullAddress = (addressObj.country !== '' && addressObj.country != null) ? `${fullAddress}${addressObj.country}, ` : `${fullAddress}`;
            fullAddress = (addressObj.postalCode !== '' && addressObj.postalCode != null) ? `${fullAddress}${addressObj.postalCode}` : `${fullAddress}`;
        }
        user.fullAddress = fullAddress;
        user.userDetails = user;
        user.showDetails = true;

        user.isLoader_UserDetails = false;
        user.isLoader_UserOperation = false;

    }


    const findUser = () => {
        let reqObj = {}
        setIsLoader(true);
        if (props.practiceId) {
            reqObj.practiceId = props.practiceId
        }
        return UserService.findUser(reqObj)
            .then((response) => {
                console.log(response)
                setUserList(response.data);
                setIsLoader(false)
            })
            .catch(error => {
                setIsLoader(false);
                console.log(error)
            })
    }

    useEffect(() => {

        findUser()
    }, [])


    return (
        <div className='table-responsive'>
            {isLoader && <div className="ui">
                <div className="ui active dimmer">
                    <div className="ui indeterminate text loader"></div>
                </div>
            </div>}
            {userList ?
                <Table2 desktopHiddenColumns={desktopHiddenColumns} hiddenColumns={hiddenColumns} export searchable data={userList} columns={columns} loading={isLoader} extraButtons={[{
                    className: 'btn btn-primary',
                    title: "Add Practice User",
                    children:
                        <span><i className='icon plus' /></span>
                    ,
                    onClick: () => {
                        setShowAdd(true);
                    }
                }]} />
                : null}
            <ModalBox open={openModal} onClose={() => setOpenModal(false)} title="Edit User">
                <UserEdit userId={selectedUser?.id} practiceId={props.practiceId} onClose={() => { setOpenModal(false); }} refresh={() => { findUser(); }} />
            </ModalBox>

            <ModalBox open={statusModal} onClose={() => setStatusModal(false)}>
                <div className='row d-flex justify-content-between align-items-center'>
                    <div className='col'>
                        {selectedUser?.isActive ? <p>{MessageSetting.LoginServiceuser.deactivateConfirmation}</p> : <p>{MessageSetting.LoginServiceuser.activateConfirmation} </p>}
                    </div>
                    <div className='col-auto'>
                        <button className='btn btn-primary' onClick={(e) => { e.preventDefault(); statusHandler() }} >OK</button>
                        <button className="btn btn-secondary ms-3" onClick={(e) => { e.preventDefault(); setStatusModal(false) }}>{label.common.cancel}</button>
                    </div>
                </div>
            </ModalBox>

            <ModalBox open={resetModal} onClose={() => setResetModal(false)}>
                <div className='row d-flex justify-content-between align-items-center'>
                    <div className='col'>
                        <p>{MessageSetting.LoginServicecommon.resetPasswordConfirmation}</p>
                    </div>
                    <div className='col-auto'>
                        <button className='btn btn-primary' onClick={resetHandler}>OK</button>
                        <button className="btn btn-secondary ms-3" onClick={() => setResetModal(false)}>{label.common.cancel}</button>
                    </div>
                </div>
            </ModalBox>
            <ModalBox open={showAdd} onClose={() => { setShowAdd(false) }} title="Add User">
                <UserAdd onClose={() => { setShowAdd(false) }}  refresh={() => { findUser(); }}/>
            </ModalBox>

        </div>
    )
}


export default UserSettingsTable
